import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { uniqueId } from 'lodash';

@Component({
  selector: 'aprova-radio',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioComponent implements OnInit {
  private readonly _cdr = inject(ChangeDetectorRef);

  @Input()
  public id: string = uniqueId('aprova-radio-');

  @Input()
  public name: string = '';

  @Input({ required: true })
  public label: string = '';

  @Input({ required: true })
  public value: string | number = '';

  @Input()
  public control = new FormControl<boolean | string | number>(false);

  @Input()
  public labelClass: string = '';

  @Input()
  public leftLabel: boolean = false;

  @Input()
  public checked: boolean = false;

  @Input()
  public disabled: boolean = false;

  @Input()
  public color: string = '#06929F';

  @Output()
  onChange = new EventEmitter<string | number>();

  ngOnInit(): void {
    this.checked = this.value === this.control.value;
    this.control.valueChanges.subscribe((val) => {
      this.checked = this.value === val;
      this._cdr.markForCheck();
    });
  }

  onInputChange(event: any): void {
    this.control.setValue(this.value);
    this.onChange.emit(this.value);
    this.checked = event.target.value === this.control.value;
  }
}
